export const CLIENT_ROLE_LABELS = {
  CLIENT_OWNER: "Owner",
  CLIENT_MANAGER: "Manager",
  CLIENT_CONTRIBUTOR: "Contributor",
  CLIENT_VIEWER: "Viewer",
};

export const CLIENT_ROLE_DESCRIPTIONS = {
  CLIENT_OWNER: "Full access including team and settings management.",
  CLIENT_MANAGER: "Can manage content, leads, and invite employees (except owners).",
  CLIENT_CONTRIBUTOR: "Can edit communities, courses, and opportunities.",
  CLIENT_VIEWER: "Read-only access to assigned areas.",
};

export function formatClientRole(role) {
  return CLIENT_ROLE_LABELS[role] || role || "—";
}

export function formatTeamMemberName(user) {
  const name = [user?.firstName, user?.lastName].filter(Boolean).join(" ").trim();
  return name || user?.email || "Team member";
}

export function teamMemberStatusTone(status) {
  const s = String(status || "").toUpperCase();
  if (s === "ACTIVE") return "active";
  if (s === "INVITED") return "invited";
  if (s === "DISABLED") return "disabled";
  return "muted";
}
